import { useState, useEffect } from 'react';
import { X, AlertCircle, RefreshCw } from 'lucide-react';
import { getNotificationInitStatus, initializeNotifications } from '../../lib/notifications';
import { isIOSWebViewGold } from '../../lib/platform';
import { auth } from '../../lib/firebase';

export function NotificationErrorBanner() {
  const [visible, setVisible] = useState(false);
  const [retrying, setRetrying] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const isAdmin = auth.currentUser?.email === 'breadflowbybadabec@gmail.com';

  useEffect(() => {
    if (!isIOSWebViewGold() || !auth.currentUser || dismissed) {
      return;
    }

    const checkStatus = () => {
      const status = getNotificationInitStatus();

      if (status.error && !status.initialized) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    checkStatus();
    const interval = setInterval(checkStatus, 5000);

    return () => clearInterval(interval);
  }, [dismissed]);

  const handleRetry = async () => {
    setRetrying(true);
    try {
      await initializeNotifications();
      const status = getNotificationInitStatus();
      if (status.initialized && !status.error) {
        setVisible(false);
      }
    } catch (error) {
      console.error('Retry failed:', error);
    } finally {
      setRetrying(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    setVisible(false);
  };

  if (!visible || !auth.currentUser) {
    return null;
  }

  const status = getNotificationInitStatus();

  return (
    <div className="fixed top-20 left-0 right-0 z-40 md:pl-[66px]">
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mx-4 rounded shadow-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <AlertCircle className="h-5 w-5 text-yellow-400" />
          </div>
          <div className="ml-3 flex-1">
            <h3 className="text-sm font-medium text-yellow-800">
              Push Notifications Unavailable
            </h3>
            <div className="mt-2 text-sm text-yellow-700">
              <p>We couldn't set up push notifications. Try reopening the app or tapping retry below.</p>
              {isAdmin && status.error && (
                <p className="mt-1 text-xs font-mono bg-yellow-100 p-2 rounded">
                  {status.error}
                </p>
              )}
            </div>
            <div className="mt-3 flex gap-2">
              <button
                onClick={handleRetry}
                disabled={retrying}
                className="inline-flex items-center gap-1 px-3 py-1.5 border border-transparent text-sm font-medium rounded text-yellow-700 bg-yellow-100 hover:bg-yellow-200 focus:outline-none disabled:opacity-50"
              >
                <RefreshCw className={`w-4 h-4 ${retrying ? 'animate-spin' : ''}`} />
                {retrying ? 'Retrying...' : 'Retry Now'}
              </button>
              <button
                onClick={handleDismiss}
                className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded text-yellow-700 bg-yellow-100 hover:bg-yellow-200 focus:outline-none"
              >
                Dismiss
              </button>
            </div>
          </div>
          <div className="ml-auto pl-3">
            <button
              onClick={handleDismiss}
              className="inline-flex text-yellow-400 hover:text-yellow-500"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
